<template>
    <div class="table-head head-fixed waiting-fixed">
        <div class="table-tr">
            <div class="table-th cell-length">{{ __("Patient") }}</div>
            <div class="table-th cell-status">{{ __("Registration status") }}</div>
            <div class="table-th cell-invite">{{ __("Invitation") }}</div>
            <div class="table-th cell-therapist">{{ __("Physician") }}</div>
            <div class="table-th cell-institution">{{ __("Institution") }}</div>
            <div class="table-th cell-controls"></div>
        </div>
    </div>
</template>

<script>
import TableHeader from '@components/PatientsMatrix/TableHeader'

export default {
    extends: TableHeader
}
</script>
